(function () {
  if (window.__offerWidgetInitialized) return;
  window.__offerWidgetInitialized = true;

  function paintCard(card, selected) {
    card.setAttribute('data-selected', selected ? 'true' : 'false');
  }

  function initializeGroup(widgets) {
    const first = widgets[0];
    const sectionId = first.dataset.sectionId;
    const productFormId = first.dataset.productFormId;
    const isVariantMode = first.dataset.offerMode === 'variant';

    const giftPromoContainer =
      document.querySelector('#gift-product-promo[data-section-id="' + sectionId + '"]') ||
      document.getElementById('gift-product-promo');
    const tagTextContainers = giftPromoContainer
      ? giftPromoContainer.querySelectorAll('.tag-text-container')
      : [];
    const quantityInputs = Array.from(
      document.querySelectorAll('[data-section-quantity-input="' + sectionId + '"]')
    );

    let progressFill = giftPromoContainer
      ? giftPromoContainer.querySelector('[data-progress-fill]')
      : first.querySelector('[data-progress-fill]');

    const ownVariantIds = new Set(
      widgets
        .flatMap((w) => Array.from(w.querySelectorAll('.product-card-custom')))
        .map((c) => c.dataset.variantId)
        .filter(Boolean)
    );

    function variantInputs() {
      const byFormId = Array.from(
        document.querySelectorAll('form[id="' + productFormId + '"] input[name="id"]')
      );
      const byVariant = Array.from(
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]')
      ).filter((input) => ownVariantIds.has(input.value));
      return Array.from(new Set(byFormId.concat(byVariant)));
    }

    function updateDots(circleNumber) {
      if (!progressFill) {
        progressFill = (giftPromoContainer || first).querySelector('[data-progress-fill]');
      }
      if (!progressFill) return;

      const maxSteps = 6;
      const clamped = Math.max(0, Math.min(circleNumber, maxSteps));
      progressFill.style.width = (clamped / maxSteps) * 100 + '%';
      progressFill.style.background =
        circleNumber > maxSteps
          ? 'linear-gradient(90deg, #0C3D3D 0%, #0C3D3D 79%, #EFB13D 93%, #FFDA7E 100%)'
          : '';
    }

    function applyVariantSelection(variantId) {
      if (!variantId) return;

      variantInputs().forEach((input) => {
        input.value = variantId;
        input.setAttribute('value', variantId);
        input.removeAttribute('disabled');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function selectByIndex(index, sourceCard) {
      const cardQuantity = parseInt(sourceCard.dataset.quantity || 1, 10);
      const subscriptionQuantity = parseInt(
        sourceCard.dataset.subscriptionQuantity || cardQuantity,
        10
      );
      const discountPercentage = parseFloat(sourceCard.dataset.discountPercentage || '0') || 0;
      const variantId = sourceCard.dataset.variantId;
      const cartQuantity = isVariantMode ? 1 : cardQuantity;

      quantityInputs.forEach((input) => {
        input.value = cartQuantity;
        input.setAttribute('value', cartQuantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (isVariantMode) applyVariantSelection(variantId);

      widgets.forEach((w) => {
        const cards = Array.from(w.querySelectorAll('.product-card-custom'));
        const match = isVariantMode
          ? cards.find((c) => c.dataset.variantId === variantId)
          : cards[index];
        cards.forEach((c) => paintCard(c, c === match));
      });

      let circleNumber = 0;
      if (tagTextContainers[index]) {
        circleNumber = parseInt(tagTextContainers[index].dataset.circleNumber || 0, 10);
      }
      if (!circleNumber || Number.isNaN(circleNumber)) circleNumber = cardQuantity;
      updateDots(circleNumber);

      tagTextContainers.forEach((container, idx) => {
        container.style.display = idx === index ? 'block' : 'none';
      });

      const descriptionEl = sourceCard.querySelector('[data-card-description]');
      const offerDescriptionText = document.querySelector('[data-offer-description-text]');
      if (descriptionEl && offerDescriptionText) {
        offerDescriptionText.textContent = descriptionEl.dataset.cardDescription;
      }

      document.dispatchEvent(
        new CustomEvent('variantSelected', {
          detail: {
            variantIndex: index,
            quantity: cardQuantity,
            subscriptionQuantity: subscriptionQuantity,
            discountPercentage: discountPercentage,
            sectionId: sectionId
          }
        })
      );

      window.currentOfferDiscount = discountPercentage;

      document.dispatchEvent(
        new CustomEvent('offerDiscountUpdated', {
          detail: { discountPercentage: discountPercentage, sectionId: sectionId }
        })
      );
    }

    widgets.forEach((w) => {
      Array.from(w.querySelectorAll('.product-card-custom')).forEach((card, index) => {
        card.addEventListener('click', function () {
          selectByIndex(index, this);
        });
      });
    });

    const firstCards = Array.from(first.querySelectorAll('.product-card-custom'));
    if (!firstCards.length) return;

    let defaultIndex = firstCards.length - 1;
    if (isVariantMode) {
      const preselected = firstCards.findIndex((c) => c.dataset.selected === 'true');
      if (preselected !== -1) defaultIndex = preselected;
    }
    selectByIndex(defaultIndex, firstCards[defaultIndex]);
  }

  function initializeAll() {
    const groups = new Map();
    document.querySelectorAll('[data-offer-widget]').forEach((w) => {
      const key = w.dataset.sectionId || '';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(w);
    });
    groups.forEach(initializeGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
